export default "__VITE_ASSET__DwNCraiQ__"